import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { BillingScreen } from './BillingScreen';
import type { BillingSearch } from './billing-search';

const route = getRouteApi('/billing');

export function BillingRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const onSearchChange = useCallback(
    (next: BillingSearch) => {
      void navigate({
        replace: true,
        search: () => ({
          view: next.view,
          ...(next.search === undefined ? {} : { search: next.search }),
          ...(next.status === undefined ? {} : { status: next.status }),
          ...(next.store === undefined ? {} : { store: next.store }),
          ...(next.entitlement === undefined ? {} : { entitlement: next.entitlement }),
          ...(next.type === undefined ? {} : { type: next.type }),
          ...(next.userId === undefined ? {} : { userId: next.userId }),
          ...(next.cursor === undefined ? {} : { cursor: next.cursor }),
          ...(next.event === undefined ? {} : { event: next.event }),
        }),
      });
    },
    [navigate],
  );

  return <BillingScreen search={search} onSearchChange={onSearchChange} />;
}
